/**
 * Safety Element Colors — default color per mappable element type
 *
 * @module core/modules/safety/constants/element-colors
 *
 * @description
 * Colores por defecto para los 6 tipos de elementos del módulo de seguridad
 * que se representan en el mapa. El usuario puede personalizar cada color
 * desde el panel.
 */

/** The 6 safety element types that have map representation */
export type SafetyElementId =
  | 'cameras'
  | 'alarms'
  | 'emergency'
  | 'police'
  | 'fire-stations'
  | 'civil-defense';

export const SAFETY_ELEMENT_COLORS: Record<SafetyElementId, string> = {
  'cameras':       '#3b82f6', // azul (cámaras)
  'alarms':        '#f59e0b', // ámbar (alarmas)
  'emergency':     '#ef4444', // rojo (emergencias)
  'police':        '#6366f1', // índigo (comisarías)
  'fire-stations': '#f97316', // naranja (bomberos)
  'civil-defense': '#10b981', // verde (defensa civil)
};

/** Set of IDs for quick lookup */
export const MAPPABLE_ELEMENT_IDS = new Set<string>(
  Object.keys(SAFETY_ELEMENT_COLORS),
);
